const transportationTypeConsts = {
    "sp":1,
    "agency":2
};

Object.freeze(transportationTypeConsts);
export default transportationTypeConsts;